import { lazy } from "react"
import { Root } from "src/shared/components"
import PermissionRoute from "../permission-route"
import { Navigate } from "react-router-dom"
//  --- Receive Item ---
const StockIntakeList = lazy(() => import("src/modules/inventory-management/stock-intake/pages/StockIntakeList"))

// ---Transfer ---
const ReceiveList = lazy(() => import("src/modules/inventory-management/transfer-receipt/pages/TransferReceiptList"))
const StockReceive = lazy(() => import("src/modules/inventory-management/stock-transfer/pages/StockReceive"))
const StockTransferList = lazy(() => import("src/modules/inventory-management/stock-transfer/pages/StockTransferList"))
const CreateStockTransfer = lazy(
  () => import("src/modules/inventory-management/stock-transfer/pages/CreateStockTransfer/")
)

// --- Stock Operation ---
const StockOperationList = lazy(
  () => import("src/modules/inventory-management/stock-operation/pages/StockOperationList")
)
const CreateStockOperation = lazy(
  () => import("src/modules/inventory-management/stock-operation/pages/CreateStockOperation")
)
const StockOperationDetail = lazy(
  () => import("src/modules/inventory-management/stock-operation/pages/StockOperationDetail")
)

const inventoryManagementRoutes = {
  path: "inventory-management",
  element: <Root />,
  children: [
    {
      index: true,
      element: <Navigate to={"/app/inventory-management/stock-intake"} />
    },
    {
      path: "stock-intake",
      element: (
        <PermissionRoute permission={"inventory:stock-intake:read"}>
          <StockIntakeList />
        </PermissionRoute>
      )
    },

    {
      path: "stock-transfer",
      element: <Root />,
      children: [
        {
          index: true,
          element: (
            <PermissionRoute permission={"inventory:stock-transfer:read"}>
              <StockTransferList />
            </PermissionRoute>
          )
        },
        {
          path: "create",
          element: (
            <PermissionRoute permission={"inventory:stock-transfer:create"}>
              <CreateStockTransfer />
            </PermissionRoute>
          )
        },

        {
          path: "stock-receive/:transferId",
          element: (
            <>
              <PermissionRoute permission={"inventory:transfer-receipt:receive"}>
                <StockReceive />
              </PermissionRoute>
            </>
          )
        }
      ]
    },
    {
      path: "transfer-receipt",
      element: (
        <PermissionRoute permission={"inventory:transfer-receipt:read"}>
          <ReceiveList />
        </PermissionRoute>
      )
    },
    {
      path: "stock-operation",
      element: <Root />,
      children: [
        {
          index: true,
          element: (
            <PermissionRoute permission={"inventory:stock-operation:read"}>
              <StockOperationList />
            </PermissionRoute>
          )
        },
        {
          path: "create",
          element: (
            <PermissionRoute permission={"inventory:stock-operation:create"}>
              <CreateStockOperation />
            </PermissionRoute>
          )
        },
        {
          path: "details/:id",
          element: (
            <PermissionRoute permission={"inventory:stock-operation:read"}>
              <StockOperationDetail />
            </PermissionRoute>
          )
        }
      ]
    }
  ]
}
export default inventoryManagementRoutes
